<div class="date-picker-modal" role="dialog" [attr.aria-label]="title">
  <header class="date-picker-modal__header">
    <h2 class="date-picker-modal__title">{{ title }}</h2>
    <button type="button" class="date-picker-modal__close" aria-label="Close" (click)="cancel()">
      <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none">
        <path d="M6 6l12 12M18 6L6 18" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" />
      </svg>
    </button>
  </header>

  <p class="date-picker-modal__selected">{{ selectedLabel() }}</p>

  <div class="date-picker-modal__calendar">
    <ngb-datepicker [startDate]="selectedNgbDate()"
                    [minDate]="minNgbDate()"
                    (dateSelect)="onDateSelect($event)"
                    [navigation]="'arrows'"
                    [showWeekNumbers]="false" />
  </div>

  <div class="date-picker-modal__actions">
    <button type="button" class="date-picker-modal__btn date-picker-modal__btn--ghost" (click)="cancel()">Cancel</button>
    <button type="button" class="date-picker-modal__btn date-picker-modal__btn--primary" (click)="confirm()">{{ confirmText }}</button>
  </div>
</div>
